import styled, { css, keyframes } from "styled-components";

// Animação de entrada do formulário
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const PageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  background: #111;
  background: radial-gradient(circle, #2a2a2a 0%, #111 100%);
  box-sizing: border-box;
`;

export const MainBox = styled.div`
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 450px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: ${fadeIn} 0.8s ease-out;

  @media (max-width: 500px) {
    max-width: 92%;
    margin: 1rem;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  transition: transform 0.6s cubic-bezier(0.86, 0, 0.07, 1);
  &.simulacao-active {
    transform: translateX(-100%);
  }
`;

const ViewBase = css`
  min-width: 100%;
  padding: 2.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LoginView = styled.div`
  ${ViewBase}
`;
export const SimulacaoView = styled.div`
  ${ViewBase}
`;

export const Logo = styled.img`
  width: 150px;
  margin-bottom: 1.5rem;
`;

export const Title = styled.h2`
  color: #ffffff;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
  text-align: center;
`;

export const LoginForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InputLabel = styled.label`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  margin-left: 0.2rem;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 0 1rem;
  color: #ffffff;
  font-size: 1rem;
  box-sizing: border-box;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #e6aa3a;
    background: rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 0 2px rgba(230, 170, 58, 0.1);
  }
`;

export const ShowPassButton = styled.button`
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  &:hover {
    color: #e6aa3a;
  }
`;

export const Link = styled.a`
  color: #e6aa3a;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  align-self: flex-end;
  margin-top: -0.5rem;
  &:hover {
    text-decoration: underline;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  height: 52px;
  background: #e6aa3a;
  border: none;
  border-radius: 12px;
  color: #111;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 0.5rem;
  transition: all 0.3s ease;
  &:hover {
    background: #ffc43d;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(230, 170, 58, 0.2);
  }
`;

export const FooterText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem;
  margin-top: 1.5rem;
  text-align: center;
  a {
    color: #e6aa3a;
    font-weight: 600;
    margin-left: 5px;
    text-decoration: none;
  }
`;

// Aviso discreto de manutenção (config/manutencao.js). Ganha um pouco mais de
// destaque quando a pessoa tenta entrar.
export const MaintenanceNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 1.25rem;
  padding: 0.65rem 0.8rem;
  font-size: 0.78rem;
  line-height: 1.45;
  text-align: left;
  color: ${({ $destaque }) => ($destaque ? "rgba(255, 255, 255, 0.85)" : "rgba(255, 255, 255, 0.55)")};
  background: rgba(230, 170, 58, ${({ $destaque }) => ($destaque ? 0.1 : 0.05)});
  border: 1px solid rgba(230, 170, 58, ${({ $destaque }) => ($destaque ? 0.45 : 0.2)});
  border-radius: 8px;
  transition: all 0.25s ease;
  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: #e6aa3a;
  }
`;

export const ErrorMessage = styled.p`
  color: #ff5c5c;
  font-size: 0.85rem;
  margin-top: 1rem;
  background: rgba(255, 92, 92, 0.1);
  padding: 0.8rem;
  border-radius: 8px;
  width: 100%;
  text-align: center;
`;

export const ToggleButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 30px;
  color: #fff;
  padding: 0.6rem 1.2rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  z-index: 10;
  transition: all 0.3s ease;
  &:hover {
    background: rgba(230, 170, 58, 0.15);
    border-color: #e6aa3a;
  }
`;

// --- ESTILOS DO SIMULADOR ---

export const SimulationForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const InvestmentInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
`;

export const InvestmentLabel = styled.label`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
`;

export const InvestmentInputContainer = styled.div`
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 0 1.2rem;
  color: #e6aa3a;
  width: 100%;
  box-sizing: border-box;

  span {
    font-size: 1.4rem;
    font-weight: 700;
    margin-right: 8px;
  }
`;

export const InvestmentInput = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: #e6aa3a;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 0.8rem 0;
  width: 100%;
`;

export const RateBadge = styled.div`
  background: ${(props) =>
    props.active ? "rgba(230, 170, 58, 0.15)" : "rgba(255, 255, 255, 0.03)"};
  color: ${(props) => (props.active ? "#e6aa3a" : "#666")};
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  border: 1px solid
    ${(props) => (props.active ? "rgba(230, 170, 58, 0.3)" : "transparent")};
  margin-top: 0.2rem;
  strong {
    margin-left: 4px;
    font-weight: 700;
  }
`;

export const RulesInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: rgba(255, 255, 255, 0.03);
  padding: 0.8rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);

  svg {
    color: #e6aa3a;
    font-size: 1rem;
    margin-top: 2px;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.5);
    span strong {
      color: #fff;
      margin-left: 3px;
    }
  }
`;

export const SliderWrapper = styled.div`
  width: 100%;
  padding: 0.5rem 0;
`;

export const SliderInput = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  outline: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 22px;
    height: 22px;
    background: #e6aa3a;
    border-radius: 50%;
    cursor: pointer;
    border: 4px solid #222;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }
`;

export const ResultsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8rem;
  width: 100%;
`;

export const ResultBox = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 1rem;
  text-align: center;

  ${(props) =>
    props.highlight &&
    css`
      grid-column: 1 / -1;
      background: #e6aa3a;
      border: none;
      p,
      strong {
        color: #111;
      }
    `}
`;

export const ResultLabel = styled.p`
  margin: 0 0 0.3rem 0;
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ResultValue = styled.strong`
  display: block;
  font-size: 1.2rem;
  color: #ffffff;
  font-weight: 700;
`;
